import Vue from 'vue';
import Vuex from "vuex";
import { getStoreBuilder } from "vuex-typex";
import { JustoneGameState } from './game';
import _ from 'lodash';
import { JustoneClient } from '@/client';
import { gameStore } from './game/store';
import { Action } from '@/actions';

Vue.use(Vuex);

const rootBuilder = getStoreBuilder<RootState>();
export const rootModuleBuilder = rootBuilder.module("rootModule", {});

export const dispatchJoin = rootModuleBuilder.dispatch(async (ctx, { name, gid }: { name: string, gid: string | undefined }) => {
    const prom = new Promise((resolve, reject) => {
        const client = JustoneClient.getInstance(name, gid);
        client.onmessage = message => {
            const payload = <any>message;
            switch (message.action) {
                case Action.playerJoined:
                    gameStore.commitPlayerJoined(payload);
                    break;
                case Action.nextTurn:
                    gameStore.commitNextTurn(payload);
                    break;
                case Action.hintAdded:
                    gameStore.commitHintAdded(payload);
                    break;
                case Action.showHints:
                    gameStore.commitShowHints(payload);
                    break;
                case Action.revealHints:
                    gameStore.commitRevealHints(payload);
                    break;
                default:
                    break;
            };
        };
        client.onclose = (r) => {
            reject(r);
        };
        client.onopen = () => {
            client.send({
                action: Action.join
            });
        };
    });
    (<any>window).prom = prom;
    return prom;
}, "join");

export interface RootState {
    game: JustoneGameState
}

const stateGetter = rootModuleBuilder.state();
export const rootStore = {
    get state() { return stateGetter() },

    dispatchJoin
}


export const vuexStore = rootBuilder.vuexStore();

